<template>
  <div class="frisbuy-interaction-wrapper" ref="frame">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkIdForSizeInterval: undefined,
    };
  },

  mounted() {
    this.handleResizeGuidelines();

    window.addEventListener("resize", this.setGuidelinesInterval);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setGuidelinesInterval);
  },

  methods: {
    handleResizeGuidelines() {
      const subW = this.$refs?.frame?.offsetWidth / 400;

      if (typeof subW === "number" && subW > 0) {
        document.documentElement.style.setProperty(
          "--frisbuy-interaction-width",
          subW
        );

        clearInterval(this.checkIdForSizeInterval);
        this.checkIdForSizeInterval = undefined;
      } else if (!this.checkIdForSizeInterval) {
        this.setGuidelinesInterval();
      }
    },

    setGuidelinesInterval() {
      this.$nextTick(() => {
        /* [BUG]
          setInterval is needed for check offsetWidth.
          ".frisbuy-interaction-wrapper" can not to get offsetWidth in first check
        */
        this.checkIdForSizeInterval = setInterval(() => {
          this.handleResizeGuidelines();
        }, 250);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap");

.frisbuy-interaction-wrapper {
  position: absolute;
  inset: 0;

  width: unset;
  height: unset;
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: 9 / 16;
  margin: auto;
}
</style>
